import React from 'react';
import VideoCard from '@opm/pages/Videos/components/videoCard';
import './index.scss';

interface IUgcTrendVideoThumbProps {
  /**
   * 已经在 hook 层（useUgcTrendsData / useDrawerRelatedCreatives）
   * 通过 toVideoCardItem 适配过的对象，可直接交给 VideoCard 消费。
   */
  item: any;
  onClick?: (item: any) => void;
}

export default function UgcTrendVideoThumb({
  item,
  onClick,
}: IUgcTrendVideoThumbProps) {
  return (
    <div
      className="dbom-ugc-trend-video-thumb"
      onClick={e => {
        e.stopPropagation();
        onClick?.(item);
      }}
    >
      <VideoCard item={item} language="origin" hideKeys={['comments']} />
    </div>
  );
}
